import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CampaignModalShell } from '#/entities/campaign'
import { useCampaignUserOptions } from '#/features/campaign-enrol'
import { Select } from '#/shared/ui/select'

interface CampaignAssignDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  count: number
  busy: boolean
  onSubmit: (userId: string) => void
}

/**
 * "Assign to an agent": whose name and lines the remaining steps go out under.
 * The user list is fetched only while the dialog is open.
 */
export function CampaignAssignDialog({
  open,
  onOpenChange,
  count,
  busy,
  onSubmit,
}: CampaignAssignDialogProps) {
  const { t } = useTranslation()
  const [userId, setUserId] = useState('')
  const users = useCampaignUserOptions(open)
  return (
    <CampaignModalShell
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      title={t('campaigns.modal.assign.title', { count })}
      description={t('campaigns.modal.assign.description')}
      submitLabel={t('campaigns.modal.assign.submit', { count })}
      submitDisabled={busy || userId === ''}
      onSubmit={() => onSubmit(userId)}
    >
      <Select
        portal
        label={t('campaigns.modal.assign.agentLabel')}
        options={users.options}
        loading={users.isLoading}
        value={userId}
        placeholder={t('campaigns.modal.assign.agentPlaceholder')}
        onValueChange={setUserId}
      />
    </CampaignModalShell>
  )
}
